import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-d82ab0c8"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  id: "Detail_3d",
  ref: "contain"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "loadbar"
}, [/*#__PURE__*/_createElementVNode("span", {
  id: "bar"
})], -1));
const _hoisted_3 = [_hoisted_2];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, _hoisted_3, 512)]);
}